import React, { ReactNode } from 'react';
import { Link } from 'gatsby';

import { IPageContext } from '../../interfaces/pagecontext.interface';
import { Localization } from '../../enums/localization.enum';

interface Props {
  to: string;
  className?: string;
  pageContext: IPageContext;
  children: ReactNode;
}

const LinkTo = ({ to, pageContext, className, children }: Props) => {
  const { currentLocale } = pageContext;
  const currentPrefix = currentLocale === Localization.Uzbekistan ? Localization.Uzbekistan : '';

  return (
    <Link className={className} to={`${!currentPrefix.length ? '' : `/${currentPrefix}`}${to}`}>
      {children}
    </Link>
  );
};

export default LinkTo;
